import Stepper from '../../atoms/navigation/Stepper'

type RegisterStepViewProps = {
  step: number
}

export default function RegisterStepView({ step }: RegisterStepViewProps) {
  return (
    <Stepper
      active={step}
      steps={[
        { id: 1, label: 'リセット送信', completed: step > 0 },
        { id: 2, label: 'リセット完了', completed: step > 1 },
      ]}
    />
  )
}
